import styled from 'styled-components';
import { AppPlatform } from 'modules/mobileApps/types';
import { useModalsContext } from 'modules/sendingPlatforms/contexts';
import noop from 'utils/noop';
import { Apple24, Android24 } from 'ui/icons';
import { BUTTON_SIZES, DestructiveButton } from 'ui/button';
import { FormField } from 'ui/formField';
import { BasicSelect } from 'ui/selects';
import { MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { Body2, colors, spacing } from 'ui/theme';
import { mockCustomMtaMobileApps } from '../../../../mockData';

const LabelWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: ${spacing.quarter};
`;

export const DeleteDestinationModal = () => {
  const { hideModal } = useModalsContext();

  const iosApps = mockCustomMtaMobileApps.filter((app) => app.platform === AppPlatform.IOS);
  const androidApps = mockCustomMtaMobileApps.filter((app) => app.platform === AppPlatform.ANDROID);

  return (
    <Modal
      id={'delete-destination-modal'}
      isModalOpen
      onClose={hideModal}
      variant={MODAL_VARIANTS.DELETE}
    >
      <ModalHeader>Delete destination and replace applications?</ModalHeader>
      <ModalBody>
        <Body2>
          Applications associated with <b>Test --- Fiterable</b> is currently the target destination
          for campaigns. Please select another application to be the replacement destination
        </Body2>
        <FormField
          inputId="ios-app-select"
          labelText={
            <LabelWrapper>
              <Apple24 color={colors.textSecondary} />
              Mock iOS Application
            </LabelWrapper>
          }
        >
          <BasicSelect
            id="ios-app-select"
            isFullWidth
            placeholder="Select replacement iOS application"
            options={iosApps.map((app) => ({
              id: app.id?.toString(),
              label: app.name,
              value: app.name,
            }))}
          />
        </FormField>
        <FormField
          inputId="android-app-select"
          labelText={
            <LabelWrapper>
              <Android24 color={colors.textSecondary} />
              Mock Android Application
            </LabelWrapper>
          }
        >
          <BasicSelect
            id="android-app-select"
            isFullWidth
            placeholder="Select replacement Android application"
            options={androidApps.map((app) => ({
              id: app.id?.toString(),
              label: app.name,
              value: app.name,
            }))}
          />
        </FormField>
      </ModalBody>
      <ModalFooter>
        <DestructiveButton isLoading={false} onClick={noop} size={BUTTON_SIZES.LARGE}>
          Delete destination and replace application
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
